import KeuzeNLResource from '@/resources/KeuzeNLResource';

export default class KeuzeNL {
    constructor() {
        this.Resource = new KeuzeNLResource()
    }

    async connect (websiteId) {
        return await this.Resource.connect(websiteId)
    }
}
